// categories.js

const categories = [
    {
        id: 1,
        codigo: 'EMBARGOS_DESMATAMENTO',
        nome: 'Embargos e desmatamento',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.embargosDesmatamentos'
    },
    {
        id: 2,
        codigo: 'SOCIAL',
        nome: 'Social',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.social'
    },
    {
        id: 3,
        codigo: 'AREAS_PROTEGIDAS',
        nome: 'Áreas protegidas',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.areasProtegidas'
    },
    {
        id: 4,
        codigo: 'REPRESENTANTES',
        nome: 'Representantes',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.representantes'
    },
    {
        id: 5,
        codigo: 'EMBARGOS',
        nome: 'Embargos',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.embargos'
    },
    {
        id: 6,
        codigo: 'DESMATAMENTOS',
        nome: 'Desmatamentos',
        nomeKey: 'mensagens.monitoramentoSocioambiental.categorias.desmatamentos'
    }
];

export default categories;
